(() => {
  const recommendationHeader = 'X-Newton-Cart-Recommendation';

  const getCartAddUrl = () => {
    const configuredUrl = window.Theme?.routes?.cart_add_url;
    if (configuredUrl) return configuredUrl.endsWith('.js') ? configuredUrl : `${configuredUrl}.js`;

    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}cart/add.js`;
  };

  const getSectionIds = () => Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((node) => node.dataset.sectionId)
    .filter(Boolean);

  const getRecommendationOption = (form) => {
    const card = form.closest('[data-cart-recommendation-card]');
    const select = card?.querySelector('[data-recommendation-select]');
    return select?.options?.[select.selectedIndex] || null;
  };

  const getRequestBody = (form, option, sections) => {
    if (option?.dataset.bundle === 'true') {
      const bundleUuid = `cart-rec-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
      const bundleLabel = option.dataset.bundleLabel || 'Rest & Relax Set';
      return {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number.parseInt(option.dataset.bundleV1Id, 10),
              quantity: 1,
              properties: { _bundle_uuid: bundleUuid, _bundle_label: bundleLabel, Bundle: bundleLabel },
            },
            {
              id: Number.parseInt(option.dataset.bundleV2Id, 10),
              quantity: 1,
              properties: { _bundle_uuid: bundleUuid, _bundle_label: bundleLabel, Bundle: bundleLabel },
            },
          ],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      };
    }

    const formData = new FormData(form);
    formData.set('id', option?.dataset.variantId || formData.get('id') || '');
    formData.set('quantity', formData.get('quantity') || '1');
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);
    return { body: formData };
  };

  const addRecommendation = async (form) => {
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      const sections = getSectionIds();
      const option = getRecommendationOption(form);
      const request = getRequestBody(form, option, sections);
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          [recommendationHeader]: 'true',
          ...(request.headers || {}),
        },
        body: request.body,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Cart recommendation add failed');

      const cart = await fetch('/cart.js', { cache: 'no-store' }).then((result) => result.json());
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            source: 'cart-recommendations',
            itemCount: cart.item_count,
            sections: data.sections || {},
          },
        },
      }));

      if (typeof window.safeOpenCartDrawer === 'function') {
        window.safeOpenCartDrawer();
      } else {
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
      }
    } catch (error) {
      console.error('Recommendation add error', error);
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[data-newton-cart-recommendation-form]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    void addRecommendation(form);
  }, true);
})();
